export default __webpack_public_path__ + "static/media/live-and-interactive.2a972f1e.svg";